import './news-list.scss';
